import { useController } from 'react-hook-form'

import { TextAreaField, TextField } from '../../legacy-form-fields'
import { DormakabaConnectionFormValues } from './dormakaba.schema'

const useTextFieldProps = (name: keyof DormakabaConnectionFormValues) => {
  const { field, fieldState } = useController<DormakabaConnectionFormValues>({ name })
  return {
    errorLabel: fieldState.error?.message,
    isError: Boolean(fieldState.error),
    name: field.name,
    onBlur: field.onBlur,
    onChange: field.onChange,
    value: field.value ?? '',
  }
}

export const DormakabaFields = () => {
  const host = useTextFieldProps('host')
  const protocol = useTextFieldProps('protocol')
  const tokenHost = useTextFieldProps('tokenHost')
  const tokenProtocol = useTextFieldProps('tokenProtocol')
  const requesterId = useTextFieldProps('requesterId')
  const username = useTextFieldProps('username')
  const password = useTextFieldProps('password')
  const clientId = useTextFieldProps('clientId')
  const clientSecret = useTextFieldProps('clientSecret')
  const scope = useTextFieldProps('scope')
  const config = useTextFieldProps('config')

  return (
    <div className="integration-configuration">
      <TextField {...host} label="Host" placeholder="Enter Dormakaba Host" />
      <TextField {...protocol} label="Protocol" placeholder="https" />
      <TextField {...tokenHost} label="Token Host" placeholder="Enter Token Host" />
      <TextField {...tokenProtocol} label="Token Protocol" placeholder="https" />
      <TextField {...requesterId} label="Requester ID" placeholder="WS1" />
      <TextField {...username} label="Username" placeholder="Enter Username" />
      <TextField {...password} label="Password" placeholder="Enter Password" type="password" />
      <TextField {...clientId} label="Client ID" placeholder="Enter Client ID" />
      <TextField
        {...clientSecret}
        label="Client Secret"
        placeholder="Enter Client Secret"
        type="password"
      />
      <TextField {...scope} label="Scope" placeholder="Enter Scope" />
      <TextAreaField
        {...config}
        label="Config (optional JSON)"
        placeholder='{"key": "value"}'
        rows={4}
      />
    </div>
  )
}
